<template lang="pug">
section.mobile(v-scroll-mobile-container)
	.actions
		.action.hide(ref="beneficios", v-scroll-mobile="{container: 'beneficios'}"): a.button(href="#beneficios") Benefícios
</template>

<script>
export default {
	name: "Mobile"
}
</script>